const handleSearchPanel = () => {
  const $trigger = $('.js-search-trigger');
  const $searchPanel = $('.search-panel');

  $trigger.on('click', function(event) {
    const $navUtilities = $('.nav-utilities');
    const $activeMenuDropdown = $('.nav-utilities .menu__item--open-dropdown');
    const hasOpenDropdown = $activeMenuDropdown.length > 0;
    const hasOpenMobileNav = $navUtilities.hasClass('is-open');

    // Set offset top position on dropdowns and close buttons
    setOffsetTop();

    if (hasOpenDropdown) {
      $activeMenuDropdown
        .removeClass('menu__item--open-dropdown')
        .find('ul')
        .removeClass('is-active');

      $activeMenuDropdown
        .find('.menu__close')
        .removeClass('is-active');

      setTimeout(function() {
        toggleSearchPanel($searchPanel);
      }, 400);
    } else if (hasOpenMobileNav) {
      $navUtilities
        .removeClass('is-open');

      $('.nav-trigger')
        .removeClass('is-active');

      setTimeout(function() {
        toggleSearchPanel($searchPanel);
      }, 400);
    } else {
      toggleSearchPanel($searchPanel);
    }

    event.preventDefault();
  });

  $('.search-panel__close').on('click', function(event) {
    toggleSearchPanel($searchPanel);

    event.preventDefault();
  });
}

handleSearchPanel();

const toggleSearchPanel = ($container) => {
  const $closeDropdownButton = $container.find('.search-panel__close');

  $container
    .toggleClass('is-active');

  $closeDropdownButton
    .toggleClass('is-active');

  if ($container.hasClass('is-active')) {
    $container.find('input[type=search]').focus();
  } else {
    $container.find('input[type=search]').blur();
  }
}

const setOffsetTop = () => {
  const $searchPanel = $('.search-panel');
  const $headerBar = $('.header .header__bar');
  let offsetTop = 0;

  if ($headerBar.length > 0) {
    offsetTop = $headerBar.outerHeight();
  }

  $searchPanel
    .css('top', offsetTop);
}

$('.search-panel input[type=search]').on('input', function(event) {
  const $this = $(this);
  const isBlankField = $this.val().length === 0;

  if (isBlankField) {
    $('.search-panel .boost-pfs-search-suggestion-no-result').hide();
  }
});
